import { BUSINESS_DAYS } from 'shared/utils/businessHoursDisplay';
import { yupEnum, yupObject, yupString } from 'shared/utils/YupUtils';
import { z } from 'zod';

export const businessHoursRowYupSchema = yupObject({
  business_day: yupEnum(BUSINESS_DAYS, null),
  from_time: yupString(),
  to_time: yupString(),
});

const businessHoursTime = z
  .string()
  .nullish()
  .transform((value) => value ?? '');

export const businessHoursRowSchema = z.object({
  business_day: z.enum(BUSINESS_DAYS).nullable().catch(null).default(null),
  from_time: businessHoursTime,
  to_time: businessHoursTime,
});
